import { inject } from '@angular/core';
import { CanActivateFn, RedirectCommand, Router } from '@angular/router';
import { AuthService } from '@services/auth.service';
import { UserRoles } from '../models/enums/UserRoles';
import { UserOrganizationStorageService } from '../services/user-organization-storage.service';

export function authGuard(role?: UserRoles): CanActivateFn {
    return () => {
        const userOrganizationStorageService: UserOrganizationStorageService = inject(UserOrganizationStorageService);
        const authService: AuthService = inject(AuthService);

        const router: Router = inject(Router);
        const user = authService.user();

        const userOrganizationData = userOrganizationStorageService.getUserOrganization();

        if (!user) {
            authService.logout();
            return new RedirectCommand(router.parseUrl('/login'), {
                replaceUrl: false
            });
        }

        const roleToCompare = userOrganizationData && user.roleId ? userOrganizationData.roleId : user.roleId;
        if (!roleToCompare) {
            return new RedirectCommand(router.parseUrl('/login'), {
                replaceUrl: false
            });
        }

        const isAuthorized = !role || role <= roleToCompare;
        if (!isAuthorized) {
            return new RedirectCommand(router.parseUrl('/login'), {
                replaceUrl: false
            });
        }

        return isAuthorized;
    };
}
